/* eslint-disable react/prop-types */
import { MediaModel } from "@/database";
import { useNavigate } from "react-router-dom";

import { MEDIA_STATUS } from "../../constants";
import { Eye } from "lucide-react";
import RenderPremiereSchedule, {
  isPremiereChipVisible,
} from "./RenderPremiereSchedule";

interface RenderEngagementProps {
  media: MediaModel;
  paramFilter?: URLSearchParams;
  tab?: string;
}

export const RenderEngagement: React.FC<RenderEngagementProps> = ({
  media,
  paramFilter,
  tab,
}) => {
  const navigate = useNavigate();
  const handleMediaEdit = () => {
    const cleanParams = new URLSearchParams();
    if (paramFilter) {
      paramFilter.forEach((value: string, key: string) => {
        if (value && !value.includes("nextInit, navigateOptions")) {
          cleanParams.append(key, value);
        }
      });
    }

    if (tab) {
      cleanParams.append("tab", tab);
    }

    navigate(`/media/${media.id}/details?${cleanParams.toString()}`);
  };

  const premiereChipVisible = isPremiereChipVisible(media);

  return media.status !== -2 ? (
    <div
      className={
        premiereChipVisible
          ? "h-100 d-flex flex-column justify-content-center align-items-start gap-2"
          : ""
      }>
      <div className={`text-center ${premiereChipVisible ? "mt-4" : ""}`}>
        <RenderPremiereSchedule media={media} />
      </div>
      {!premiereChipVisible && (
        <span className="text-primary H">
          {" "}
          {new Intl.NumberFormat("en-IN").format(
            Number(media.views?.views) ?? 0
          )}
        </span>
      )}
      {premiereChipVisible ? null : media.media_status ===
          MEDIA_STATUS.MEDIA_STATUS_DRAFT ||
        (!media.youtubedata?.view_count && !media.views?.views) ? (
        <div className="text-center">--</div>
      ) : (
        <div className="d-flex flex-column gap-2">
          {media.youtubedata?.view_count && (
            <div className="reach d-flex align-items-center justify-content-start gap-1">
              <i
                className={`bi-youtube`}
                style={{ color: "red", fontSize: 16 }}
              ></i>
              <span style={{ width: "30px" }}>
                {media.youtubedata?.view_count
                  ? new Intl.NumberFormat("en-IN").format(
                      Number(media.youtubedata.view_count)
                    )
                  : "0"}
              </span>
            </div>
          )}
          {media.views?.views !== undefined &&
            media.views?.views !== null &&
            media.socials?.some((s) => s.job_type === "denmark") && (
              <div className="reach d-flex align-items-center justify-content-start gap-1">
                <Eye
                  style={{
                    width: "16px",
                    height: "16px",
                    color: media.status !== 10 ? "gray" : "#000000",
                  }}
                />
                <span style={{ width: "30px" }}>
                  {new Intl.NumberFormat("en-IN").format(
                    Number(media.views?.views ?? 0)
                  )}
                </span>
              </div>
            )}
          <div className="progress-ratio w-100 H"></div>
        </div>
      )}
      {!media.is_mandatory || media?.media_state !== 1 ? (
        <button
          type="button"
          onClick={handleMediaEdit}
          className="btn btn-outline-primary H"
        >
          Edit Draft
        </button>
      ) : (
        <span className="text-primary H">
          {" "}
          {media.views?.views
            ? new Intl.NumberFormat("en-IN").format(Number(media.views.views))
            : "0"}
        </span>
      )}
    </div>
  ) : (
    "--"
  );
};
